import { render, staticRenderFns } from "./AdminPolicyView.vue?vue&type=template&id=6cfbbf17"
import script from "./AdminPolicyView.vue?vue&type=script&lang=js"
export * from "./AdminPolicyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports